import { z } from 'zod';

import { PaymentDueId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const DeferDelinquentInterestEvent = BaseLoanEvent.extend({
  type: z.literal('deferDelinquentInterest'),
  paymentDueId: PaymentDueId,
});

export type DeferDelinquentInterestEvent = z.infer<typeof DeferDelinquentInterestEvent>;
